import Image from 'next/image';

import SealScriptLoader from '@/features/footer/SealScriptLoader';
import Description from '@/features/v2/shared/footer/Description';
import { blobUrl } from '../../constants/variables';

const Footer = () => {
  return (
    <footer className="flex flex-col gap-4 justify-center items-center mt-4">
      <SealScriptLoader />
      <div id="anj-d8eac85a-6ddc-4b18-bc18-8d7627783300" data-anj-seal-id="d8eac85a-6ddc-4b18-bc18-8d7627783300" data-anj-image-size="80" data-anj-image-type="basic-small" />
      <Description />
      <div className="flex flex-col gap-4 justify-center mt-4 items-center w-[100vw] md:h-24 bg-[radial-gradient(71.39%_51.03%_at_50%_50%,rgba(138,43,226,0.3)_0%,rgba(138,43,226,0)_98%)] md:hidden">
        <Image
          src={`${blobUrl}/ui/footer/Group.webp`}
          alt="Logo"
          height={300}
          className="w-full md:hidden"
          quality={85}
          placeholder="blur"
          width={320}
          // eslint-disable-next-line max-len
          blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAhEAACAQMDBQAAAAAAAAAAAAABAgMABAUGIWGRkqGx0f/EABUBAQEAAAAAAAAAAAAAAAAAAAMF/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECEgMRkf/aAAwDAQACEQMRAD8AltJagyeH0AthI5xdrLcNM91BF5pX2HaH9bcfaSXWGaRmknyJckliyjqTzSlT54b6bk+h0R//2Q=="
        />
      </div>
    </footer>
  );
};

export default Footer;

